export const ModalChangePasswordTranslationsCs = {
  changePassword: 'Změnit heslo',
  yourPassword: 'Vaše heslo',
  newPassword: 'Nové heslo',
  'Enter new password': 'Zadejte nové heslo znovu',
  saveButton: 'Uložit',
};
